import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { PersonOutline, MoreVert, ExitToAppOutlined } from '@material-ui/icons';

import ClientInformation from '../../components/Client/ClientInformation';

import './right-sidebar.css';
import { Button, Divider, Grid } from '@mui/material';

const loadClient = currentClient => {
    if(Object.keys(currentClient).length > 0) {
        return <ClientInformation client={currentClient} />
    }

    return <></>
}

const RightSideBar = props => {
    const [popover, setPopover] = useState(false);

    return (
        <Grid className={`col-sm-2 col-md-2 col-lg-2 col-xl-2 right-sidebar ${props.openModal ? 'modal-open': ''}`}>
        {props.currentClient ? loadClient(props.currentClient) : null}
          {props.openModal
          ? null
          :
          <Grid className='identity'>
            <Divider sx={{borderColor: '#fff', borderWidth: '0.1rem', marginBottom: '1rem'}}/>
            <Grid container spacing={0} alignItems={'center'}>
              {/* `item` nos três: `xs` sem `item` é aviso do MUI no console, e
                  com `spacing={0}` no container o `item` não muda nada na tela
                  -- ver `src/avisosDoConsole.test.js`. */}
              <Grid item xs className='col-md-2 identity-content' display={'flex'} justifyContent={'center'}>
                  <PersonOutline className='person-bordered' style={{ fontSize: '32px' }} />
              </Grid>
              <Grid item container flexDirection={'column'} xs className='col-md-8 identity-content-user'>
                  {/* <Grid  style={{ marginLeft: '5%' }}> */}
                      
                        <Grid>
                        {JSON.parse(localStorage.getItem('user')).name}
                        </Grid>
                      <Grid fontSize={12}>
                          {
                            JSON.parse(localStorage.getItem('user')).type
                            ? 'Administrador'
                            : 'Suporte Técnico'
                          }
                      </Grid>
                  {/* </Grid> */}
                </Grid>
                <Grid item xs
                  display={'flex'}
                  justifyContent={'flex-end'}
                  className='identity-content'
                  onClick={() => setPopover(!popover)}
                >
                <MoreVert className={popover ? 'popover-menu-button popover-menu-button-selected' : 'popover-menu-button'} style={{ fontSize: '28px' }} />
                <Grid className={popover ? 'my-popover popover-visible' : 'my-popover'}>
                    <ul>
                        <li className='row'>
                          <Grid className='col-md-2' style={{ alignSelf: 'center' }}>
                              <PersonOutline style={{ fontSize: '16px', fontWeight: 500 }} />
                          </Grid>
                          <Grid className='col-md-7' style={{ fontSize: '12px', fontWeight: 500, alignSelf: 'center' }}>
                              Perfil
                          </Grid>
                        </li>
                        <li className='row'>
                            <Grid className='col-md-2' style={{ alignSelf: 'center' }}>
                                <ExitToAppOutlined style={{ fontSize: '16px', fontWeight: 500 }} />
                            </Grid>
                            <Grid className='col-md-7' style={{ fontSize: '12px', fontWeight: 500, alignSelf: 'center' }}>
                                Sair
                            </Grid>
                        </li>
                    </ul>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
    );
}
const mapStateToProps = state => {
    const { clients } = state;
    const { currentClient } = clients;
    return { currentClient };
};

export default connect(mapStateToProps, null)(RightSideBar);